export enum eTransportMode {
  REGIONAL_TRAIN = 'regionalTrain',
  LIGHTRAIL = 'lightRail',
  BUS = 'bus',
  PEDESTRIAN = 'pedestrian',
  CAR = "car",
  PRIVATE_BUS = "privateBus"
}
